// extracted by mini-css-extract-plugin
export default {"form":"input_form__ZUAwN","label":"input_label__XEmDw","input":"input_input__Hw53E"};